import { defineMobileFormWindow, defineMobileWindow } from "@app/overlay";
import {
    StockGatheringCompletionReserveForm,
    type StockGatheringCompletionReserveFormProps,
} from "./components/StockGatheringCompletionReserveForm/StockGatheringCompletionReserveForm";
import {
    StockGatheringCompletionReservePickContent,
    type StockGatheringCompletionReservePickContentProps,
} from "./components/StockGatheringCompletionReservePickContent/StockGatheringCompletionReservePickContent";

/** Реестр overlay-окон карточки комплектования КВ. */
export const stockGatheringCompletionCardWindows = {
    reserve: defineMobileFormWindow<StockGatheringCompletionReserveFormProps>({
        key: "stock.gatheringCompletion.reserve",
        title: "Комплектование резерва",
        component: StockGatheringCompletionReserveForm,
    }),
    reservePick: defineMobileWindow<StockGatheringCompletionReservePickContentProps>({
        key: "stock.gatheringCompletion.reservePick",
        title: "Выбор резерва",
        component: StockGatheringCompletionReservePickContent,
    }),
};
